import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";
import { nextId } from "../../utils";

const expensesAdapter = createEntityAdapter();

const initialState = expensesAdapter.getInitialState();

const expensesSlice = createSlice({
	name: "expenses",
	initialState,
	reducers: {
		addExpense(state, action) {
			const id = nextId(state.ids);
			const type = action.payload;
			const expense = {
				id,
				type,
				expense: "",
				amount: 0.00,
				...(type !== "fixed" && {marginal: 0.00}),
				...(type === "mixed" && {percent: 0.00, fixed: 0.00})
			};
			expensesAdapter.addOne(state, expense);
		},
		editExpense: expensesAdapter.updateOne,
		deleteExpense(state, action) {
			expensesAdapter.removeOne(state, action.payload);
		}
	}
})

export const {
	addExpense,
	editExpense,
	deleteExpense
} = expensesSlice.actions;

export default expensesSlice.reducer

export const { selectAll: selectExpenses, selectById: selectExpenseById } = expensesAdapter.getSelectors(state => state.costPer.expenses);

export const selectExpenseIdsByType = createSelector(
	selectExpenses,
	(state, type) => type,
	(expenses, type) => {
		const filtered = expenses.filter(expense => expense.type === type);
		return filtered.map(expense => expense.id);
	}
);

export const selectExpenseTotalByType = createSelector(
	selectExpenses,
	(state, options) => options,
	(expenses, { type, field }) => {
		const filtered = expenses.filter(expense => expense.type === type);
		return filtered.reduce((accumulator, object) => {
			return accumulator + object[field];
		}, 0);
	}
);
